import { Quote, ArrowRight } from "lucide-react";

const TESTIMONIALS = [
  {
    quote: "Arrow handles our plant-to-depot dispatches with real discipline. Pickups happen when promised, and the tracking updates mean our team is never chasing a truck on the phone.",
    role: "Logistics Head",
    org: "Cement Manufacturer",
  },
  {
    quote: "We moved an entire regional office without losing a single day of work. The survey was thorough, the packing was careful, and the crew knew exactly what they were doing.",
    role: "Admin & Facilities Manager",
    org: "Telecom Company",
  },
  {
    quote: "For our e-commerce orders, Arrow became an extension of our own team. Fulfilment is consistent, issues are flagged early, and their people are easy to reach.",
    role: "Operations Lead",
    org: "D2C Consumer Brand",
  },
];

export function Testimonials() {
  return (
    <section className="w-full pb-14 sm:pb-20" data-testid="testimonials-section">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-xs font-bold uppercase tracking-widest text-primary mb-2">What clients say</div>
        <h2 className="font-heading font-black text-2xl sm:text-3xl tracking-tight" data-testid="testimonials-title">Trusted on every delivery</h2>
        <div className="mt-8 grid gap-4 md:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <figure key={t.role} className="relative border border-border bg-card p-6 flex flex-col transition-colors hover:border-primary/60" data-testid={`testimonial-card-${i}`}>
              <Quote className="h-7 w-7 text-primary/80" />
              <blockquote className="mt-4 text-sm leading-relaxed text-foreground/90 flex-1">“{t.quote}”</blockquote>
              <figcaption className="mt-6 pt-4 border-t border-border">
                <div className="font-bold text-sm">{t.role}</div>
                <div className="text-xs text-muted-foreground uppercase tracking-wide">{t.org}</div>
              </figcaption>
            </figure>
          ))}
        </div>
        <div className="mt-10 border border-primary/40 bg-primary/5 p-6 sm:p-8 flex flex-col sm:flex-row sm:items-center justify-between gap-5" data-testid="quick-quote-cta">
          <div>
            <div className="font-heading font-black text-xl sm:text-2xl tracking-tight">Ready to ship with Arrow?</div>
            <p className="text-sm text-muted-foreground mt-1">Pick a service and get an instant, transparent quote. No obligation.</p>
          </div>
          <button type="button" data-testid="get-free-quote-btn"
            onClick={() => document.getElementById("services")?.scrollIntoView({ behavior: "smooth", block: "start" })}
            className="group shrink-0 inline-flex items-center justify-center gap-2 bg-primary text-primary-foreground px-6 h-12 font-bold uppercase tracking-wide text-sm transition-transform hover:-translate-y-0.5 active:translate-y-0">
            Get a free quote <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </button>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
